import { useEffect, useState } from "react";
import Rpn from "./rpn"

export default function Calculator({expression}) {
  const [rpn, setRpn] = useState(Rpn.fromInfixNotation(expression));
  const [result, setResult] = useState(rpn?.evaluate());
  const [step, setStep] = useState(rpn?.history.first);
  const [autoplay, setAutoplay] = useState(false);

  useEffect(() => {
    let _rpn = Rpn.fromInfixNotation(expression);    
    setRpn(_rpn);
    setResult(_rpn?.evaluate());
    setStep(_rpn?.history.first);
    setAutoplay(false);
  }, [expression]);

  useEffect(() => {
    if (autoplay) {
      if (step.next !== null) {
        const timeoutId = setTimeout(() => {
          setStep(step.next);
        }, 1000);

        return () => clearTimeout(timeoutId);
      }
      else {
        setAutoplay(false);
      }
    }
  }, [step, autoplay]);

  let stepData = step?.val;

  return (
    <>
      <div>
        <h4>Evaluation:</h4>
        <div className="details">
          <div>
            Expression in RPN: {rpn?.expression ?? "convertation error"}
          </div>
          <div>
            Result: {result ?? rpn?.error}
          </div>
        </div>
      </div>
      <div className="steps">
        <h4>Step-by-step:</h4>
        <div className="details">
          <div>
            Step: { stepData?.num ?? 0 }
          </div>
          <div>
            Expression queue: {stepData?.ops.toString() ?? "[]"}
          </div>
          <div>
            Stack: {stepData?.stack.toString() ?? "[]"}
          </div>
          <div>
            Current operation:
            <div style={{paddingLeft: 20}}>
              operator: [{stepData?.operator}]
            </div>
            <div style={{paddingLeft: 20}}>
              operands: {stepData?.operands.toString() ?? '[]'}
            </div>
          </div>
          <div>
            Result: {stepData?.result ?? stepData?.error ?? (step?.prev ? "in progress" + '.'.repeat(((stepData.num-1) % 5) + 1) : "calculation not started")}
          </div>
          <div className="playback">
            <button title="step backward" className="rewind" disabled={!step?.prev || autoplay} onClick={() => setStep(step.prev)}></button>          
            <button title={(!(step?.next) ? "replay" : autoplay ? "pause" : "play")} className={(!(step?.next) ? "replay" : autoplay ? "pause" : "play")} onClick={() => {if (step?.next) setAutoplay(!autoplay); else { setStep(rpn.history.first); setAutoplay(true); }}}></button>          
            <button title="step forward" className="forward" disabled={!step?.next || autoplay} onClick={() => setStep(step.next)}></button>
          </div>
        </div>
      </div>
    </>);
}